<ng-container>
  <nb-card>
    <nb-card-header i18n="@@Synonyms">{{ title }}</nb-card-header>
    <nb-card-body>

      <p>
        <input i18n-placeholder="@@AddSynonymName" [formControl]="inputFormControl"
               nbInput
               type="text"
               fieldSize="small"
               placeholder="{{searchPlaceholder}}"
               [nbAutocomplete]="auto"
        />
      </p>
      <nb-autocomplete #auto (selectedChange)="insertTerm($event)" [handleDisplayFn]="viewHandle">
        <nb-option *ngFor="let term of terms$ | async" [value]="term">
          {{ term.header }}
        </nb-option>
      </nb-autocomplete>
      <br/>

      <ng-container *ngIf="queries.length">
        <br/>
        <table class="ngx-table__table--tiny ngx-table">
          <tr>
            <th i18n="@@Manufacturer">Бренд</th>
            <th i18n="@@Weight">Вес</th>
            <th></th>
          </tr>
          <tr *ngFor="let term of queries">
            <td>{{ term.header }}</td>
            <td>
              <input nbInput (focusout)="changeWeight(term.id, $event)" [value]="term.weight" type="number" min="1" max="1000" fieldSize="small"/>
            </td>
            <td>
              <a nbButton status="control" (click)="removeTerm(term)" size="small">
                <nb-icon icon="close"/>
              </a>
            </td>
          </tr>
        </table>
      </ng-container>

    </nb-card-body>
  </nb-card>
</ng-container>
